import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Loading} from '../../lib';



class BranchingContactSteps extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            trigger: false,
        };
        this.triggetNext = this.triggetNext.bind(this);


    }
    componentDidMount() {
        const {steps,store} = this.props;
        let trigger_value = '';
        if(store.patient.national_id){
            trigger_value = 'please_insert_your_message'
        }else{
            trigger_value = 'please_insert_patient_name'
        }

        this.triggetNext(true, trigger_value);
    }

    triggetNext(value, trigger) {
        this.setState({trigger: true});
        this.props.triggerNextStep({value: value, trigger: trigger})
    }
    render() {
        const {loading} = this.state;
        return (
            <div>
                {loading ? (
                    <Loading/>
                ) : (

                    ''
                )}
            </div>
        );
    }
}

BranchingContactSteps.propTypes = {
    steps: PropTypes.object,
    triggerNextStep: PropTypes.func,
};

BranchingContactSteps.defaultProps = {
    steps: undefined,
    triggerNextStep: undefined,
};


export default BranchingContactSteps;
